const validate = (data, setErrors, schema) => {
  const errors = {};
  schema.forEach((item) => {
    if (item.required === true) {
      if (item.type === "string") {
        if (
          !data[item.title] ||
          data[item.title] === "" ||
          data[item.title] === undefined ||
          data[item.title] === null
        ) {
          if (item.message) {
            errors[item.title] = item.message;
          } else {
            errors[item.title] = `Please enter ${item.title}`;
          }
        }
      }
      if (item.type === "number") {
        const value = data[item.title];

        if (
          value === undefined ||
          value === null ||
          value === "" ||
          !/^\d+(\.\d+)?$/.test(value)
        ) {
          errors[item.title] = `Enter a valid number`;
        }
      }
      if (item.type === "paymentAmount") {
        const value = data[item.title];
        const minAmount =
          item.min !== undefined && item.min !== null ? item.min : 0;

        if (
          value === undefined ||
          value === null ||
          value === "" ||
          !/^\d+(\.\d+)?$/.test(String(value)) ||
          parseFloat(value) <= 0
        ) {
          errors[item.title] = `Enter a valid amount`;
        } else if (parseFloat(value) < minAmount) {
          errors[item.title] =
            item.message || `Minimum amount is ${minAmount}`;
        }
      }
      if (item.type === "object") {
        if (
          !data[item.title] ||
          data[item.title] === "" ||
          data[item.title] === undefined ||
          data[item.title] === null ||
          typeof data[item.title] !== "object" ||
          Array.isArray(data[item.title])
        ) {
          if (item.message) {
            errors[item.title] = item.message;
          } else {
            errors[item.title] = `Please enter ${item.title}`;
          }
        }
      }
      if (item.type === "confirmPasswordMatch") {
        if (
          data.password &&
          data.password !== null &&
          data.password !== undefined &&
          data.password !== "" &&
          data.confirmPassword &&
          data.confirmPassword !== null &&
          data.confirmPassword !== undefined &&
          data.confirmPassword !== "" &&
          data.password !== data.confirmPassword
        ) {
          errors["confirmPassword"] = `Password confirmation failed`;
        }
      }
    } else {
      const value = data[item.title];
      if (item.type === "latitude") {
        if (
          value !== undefined &&
          value !== null &&
          String(value).trim() !== "" &&
          isNaN(parseFloat(value))
        ) {
          if (item.message) {
            errors[item.title] = item.message;
          } else {
            errors[item.title] = `Please enter ${item.title}`;
          }
        }
      }
      if (item.type === "longitude") {
        if (
          value !== undefined &&
          value !== null &&
          String(value).trim() !== "" &&
          isNaN(parseFloat(value))
        ) {
          if (item.message) {
            errors[item.title] = item.message;
          } else {
            errors[item.title] = `Please enter ${item.title}`;
          }
        }
      }
    }
  });
  setErrors(errors);
  if (Object.keys(errors).length === 0) {
    return true;
  } else {
    return false;
  }
};

export default validate;
